const stats = [
  { value: "1200+", label: "恶搞漫画" },
  { value: "每日更新", label: "持续追更" },
  { value: "80万+", label: "追更读者" },
  { value: "9.3", label: "平均评分" },
];

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[88vh] w-full items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Bold%20pop%20art%20comic%20background%20wallpaper%20of%20colorful%20explosive%20bursts%20and%20floating%20speech%20bubbles%20in%20warm%20coral%20orange%20golden%20yellow%20and%20cream%2C%20Korean%20gag%20comic%20style%20with%20halftone%20dots%2C%20playful%20energetic%20abstract%20composition%2C%20no%20text&width=1600&height=900&seq=hero-bg&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-24 text-center md:py-32">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full bg-accent-500/95 px-4 py-1.5 text-sm font-bold text-foreground-950">
          <i className="ri-emotion-laugh-fill"></i> 恶搞 · 反转 · 神展开 · 脑洞
        </span>

        <h1 className="max-w-4xl text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
          韩国歪歪漫画
          <span className="block mt-2 text-accent-400">
            脑洞魔性爆笑 · 每日追更入口
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          专注恶搞题材与反转剧情的漫画乐园，神展开脑洞、魔性沙雕一网打尽。
          反转剧情在线追更，越看越上头，专治各种无聊。
        </p>

        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#updates"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-base font-bold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-play-circle-fill"></i> 查看今日更新
          </a>
          <a
            href="#categories"
            className="inline-flex items-center gap-2 rounded-full border border-background-100/40 bg-white/10 px-7 py-3 text-base font-medium text-background-50 backdrop-blur transition-colors hover:bg-white/20 whitespace-nowrap"
          >
            <i className="ri-grid-fill"></i> 浏览漫画分类
          </a>
        </div>

        <dl className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-white/15 bg-black/20 px-4 py-5 backdrop-blur-sm"
            >
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-2xl text-accent-400 md:text-3xl">{s.value}</dd>
              <dd className="mt-1 text-sm text-background-100">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}